"use strict";
exports.__esModule = true;
exports.DBCollectionMapper = void 0;
var DBCollectionMapper;
(function (DBCollectionMapper) {
    DBCollectionMapper["_DEFAULT"] = "_default";
    DBCollectionMapper["COUNTERS"] = "counters";
    DBCollectionMapper["CONTACTS"] = "contacts";
    DBCollectionMapper["USERS"] = "users";
    DBCollectionMapper["USERS_LOG"] = "users_log";
    DBCollectionMapper["DELETED_USERS"] = "deleted_users";
    DBCollectionMapper["ORGANISATIONS"] = "organisations";
    DBCollectionMapper["ORGANISATION_MEMBERS"] = "organisation_members";
    DBCollectionMapper["INVITE_MEMBERS"] = "invite_members";
    DBCollectionMapper["ORGANISATION_ENTITIY_VIEWS"] = "organisation_entity_views";
    DBCollectionMapper["ORGANISATION_ENTITIY_ADD_FORMS"] = "organisation_entity_add_forms";
    DBCollectionMapper["ORGANISATION_FIELDS"] = "organisation_fields";
    DBCollectionMapper["ORGANISATION_FIELD_GROUPS"] = "organisation_field_groups";
    DBCollectionMapper["ORGANISATION_ACTIVITY_DEFINITIONS"] = "organisation_activity_definitions";
    DBCollectionMapper["ORGANISATION_ACTIVITIES"] = "organisation_activities";
    DBCollectionMapper["MARKETPLACE_APPS"] = "marketplace_apps";
    DBCollectionMapper["INSTALLED_APPS"] = "installed_apps";
})(DBCollectionMapper = exports.DBCollectionMapper || (exports.DBCollectionMapper = {}));
